module.exports = __webpack_public_path__ + "static/media/ic-plan.e69a66f1.svg";